import MerchantContext from '@cohort/wallet/components/contexts/MerchantContext';
import {Spinner} from '@cohort/wallet/components/Spinner';
import {useMerchant} from '@cohort/wallet/hooks/api/Merchants';
import {Colors} from '@cohort/wallet/lib/Theme';
import {languageToLocale} from '@cohort/wallet/lib/Utils';
import i18n from 'i18next';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

type MerchantContextProviderProps = {
  children: React.ReactNode;
};

const MerchantContextProvider: React.FC<MerchantContextProviderProps> = ({children}) => {
  const {data: merchant, isFetched} = useMerchant();
  const navigate = useNavigate();
  const language = languageToLocale(i18n.language);

  // i18nOwl-ignore [common.digitalAssets, common.experienceSpace, common.home, common.journeys, common.perks]
  useEffect(() => {
    if (!merchant) {
      return;
    }

    for (const [lang, terms] of Object.entries(merchant.customTerms)) {
      i18n.addResourceBundle(lang, 'common', terms, true, true);

      if (terms['experienceSpace'] !== undefined) {
        i18n.addResourceBundle(
          lang,
          'layouts',
          {
            space: {
              spaceLayout: {
                experienceSpaceTitle: terms['experienceSpace'],
              },
            },
          },
          true,
          true
        );
      }
    }
  }, [merchant, language]);

  if (isFetched && !merchant) {
    navigate('/not-found', {replace: true});
  }

  if (merchant === undefined) {
    return (
      <div className="my-auto flex h-screen w-full items-center justify-center">
        <Spinner color={Colors.Black} height="h-6" width="w-6" />
      </div>
    );
  }

  return <MerchantContext.Provider value={merchant}>{children}</MerchantContext.Provider>;
};

export default MerchantContextProvider;
